// src/pages/NewProject.tsx
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AdminLayout from '../components/layout/AdminLayout';
import ProjectForm from '../components/forms/ProjectForm';
import { createProject } from '../services/ProjectService';
import { IProject } from '../types/Project';
import { useToast } from '../hooks/useToast'; // ✅ Importar toast
import styles from '../styles/FormPages.module.css';

const DEFAULT_PLACEHOLDER_IMAGE = 'https://via.placeholder.com/1200x800.png?text=Proyecto+Paso';

const NewProject: React.FC = () => {
    const navigate = useNavigate();
    const toast = useToast(); // ✅ Usar toast

    const handleSubmit = async (formData: IProject) => {
        try {
            const { id, ...projectData } = formData; 

            let finalImageUrl = projectData.imageUrl;
            if (!finalImageUrl) {
                if (projectData.gallery.length > 0) {
                    finalImageUrl = projectData.gallery[0].url;
                } else {
                    finalImageUrl = DEFAULT_PLACEHOLDER_IMAGE;
                }
            }

            const dataToSubmit = {
                ...projectData,
                imageUrl: finalImageUrl,
                gallery: projectData.gallery.map(image => ({
                    url: image.url,
                    caption: image.caption ?? '',
                    description: image.description ?? ''
                }))
            };
            
            const newProject = await createProject(dataToSubmit as any);
            
            toast.success(
                'Proyecto creado', 
                `"${projectData.title}" ha sido creado exitosamente.`
            );
            
            navigate(`/projects/edit/${newProject.id}`);
        } catch (error: any) {
            console.error("Error al crear proyecto:", error);
            toast.error(
                'Error al crear proyecto',
                error.message || 'No se pudo crear el proyecto.'
            );
        }
    };

    return (
        <AdminLayout pageTitle="Crear Nuevo Proyecto">
            <div className={styles.formWrapper}>
                <div className={styles.pageHeader}>
                    <h2 className={styles.title}>Crear Nuevo Proyecto</h2>
                    <Link to="/projects" className={styles.backButton}>
                        ← Volver a Proyectos
                    </Link>
                </div>
                
                <ProjectForm onSubmit={handleSubmit} isEditing={false} />
            </div>
        </AdminLayout>
    );
};

export default NewProject;